export default "__VITE_ASSET__BJwMoVDb__"